package de.xtl.retroguide

import androidx.compose.ui.platform.ClipEntry

internal actual fun clipEntryWithPlainText(text: String): ClipEntry =
    ClipEntry.withPlainText(text)
